import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule, Meta, Title } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AlertModule, CarouselModule } from "@coreui/angular";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatTabsModule } from "@angular/material/tabs";
import { MatButtonModule } from "@angular/material/button";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./components/home/home.component";
import { HeaderComponent } from "./components/common/header/header.component";
import { FooterComponent } from "./components/common/footer/footer.component";
import { HeroBannerComponent } from "./components/home/hero-banner/hero-banner.component";
import { LiveActivitiesComponent } from "./components/home/live-activities/live-activities.component";
import { AboutUSComponent } from "./components/home/about-us/about-us.component";
import { AtSchoolComponent } from "./components/home/at-school/at-school.component";
import { AdvisorsComponent } from "./components/home/advisors/advisors.component";
import { VirsaInsightComponent } from "./components/home/virsa-insight/virsa-insight.component";
import { IntroComponent } from "./components/home/intro/intro.component";
import { GenreUnveiledComponent } from "./components/home/genre-unveiled/genre-unveiled.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TestimonialsComponent } from "./components/home/testimonials/testimonials.component";
import { ExpressCuriosityComponent } from "./components/home/express-curiosity/express-curiosity.component";
import { BlogComponent } from "./components/blog/blog.component";
import { PrivacyComponent } from "./components/documents/privacy/privacy.component";
import { TermConditionComponent } from "./components/documents/term-condition/term-condition.component";
import { RefundPolicyComponent } from "./components/documents/refund-policy/refund-policy.component";
import { SocialInitiativeComponent } from "./components/documents/social-initiative/social-initiative.component";
import { GenreComponent } from "./components/genre/genre.component";
import { CareersComponent } from "./components/documents/careers/careers.component";
import { GenredetailComponent } from "./components/genre/genredetail/genredetail.component";
import { ContactUsComponent } from "./components/form/contact-us/contact-us.component";
import { BookDemoDialogComponent } from "./components/form/book-demo-dialog/book-demo-dialog.component";
import { BookSessionsFormComponent } from "./components/form/book-sessions-form/book-sessions-form.component";
import { VideoModalComponent } from "./components/common/video-modal/video-modal.component";
import { BlogDeatilsComponent } from "./components/blog/blog-deatils/blog-deatils.component";
import { ConfirmationModalComponent } from "./components/common/confirmation-modal/confirmation-modal.component";
import { ClassGlimpsesComponent } from "./components/home/class-glimpses/class-glimpses.component";
import { RegisterComponent } from "./components/login/register/register.component";
import { SignInComponent } from "./components/login/sign-in/sign-in.component";
import { MastrosComponent } from "./components/home/mastros/mastros.component";
import { AdvisorModalComponent } from "./components/common/advisor-modal/advisor-modal.component";
import { NgApexchartsModule } from "ng-apexcharts";
import { OtpComponent } from "./components/login/otp/otp.component";
import { NgOtpInputModule } from "ng-otp-input";
import { PmShriComponent } from "./components/pm-shri/pm-shri.component";
import { RazorpayComponent } from "./components/common/razorpay/razorpay.component";
import { WhatsappComponent } from "./components/common/whatsapp/whatsapp.component";
import { PlaylistComponent } from "./components/genre/playlist/playlist.component";
import { Page404Component } from "./components/page404/page404.component";
import { FlatPanelComponent } from "./components/smartroom/flat-panel/flat-panel.component";
import { AllInOneComponent } from "./components/smartroom/all-in-one/all-in-one.component";
import { ProductsComponent } from "./components/home-pannel/products/products.component";
import { FeatureCardComponent } from "./components/card/feature-card/feature-card.component";
import { IfpComponent } from "./components/home-pannel/ifp/ifp.component";
import { AipComponent } from "./components/home-pannel/aip/aip.component";
import { HomePannelComponent } from "./components/home-pannel/home-pannel.component";
import { HeroPannelComponent } from "./components/home-pannel/hero-banner/hero-banner.component";
import { TestimonialComponent } from "./components/home-pannel/testimonial/testimonial.component";
import { ImpactComponent } from "./components/home-pannel/impact/impact.component";
import { IccrHeaderComponent } from "./components/common/iccr-header/iccr-header.component";
import { LoginComponent } from "./pages/login/login.component";
import { SpecTableComponent } from "./components/card/spec-table/spec-table.component";
import { OneSideImageCardComponent } from "./components/card/one-side-image-card/one-side-image-card.component";
import { UperImageCardComponent } from "./components/card/uper-image-card/uper-image-card.component";
import { IndustryTabComponent } from './components/card/industry-tab/industry-tab.component';
import { ProductCategoryComponent } from "./components/home-pannel/product-category/product-category.component";
import { UspSectionComponent } from "./components/home-pannel/usp-section/usp-section.component";
import { ProductComparisonComponent } from "./components/home-pannel/product-comparison/product-comparison.component";
import { SolutionsComponent } from "./components/home-pannel/solutions/solutions.component";
import { CaseStudiesComponent } from "./components/home-pannel/case-studies/case-studies.component";
import { ProductsPageComponent } from "./components/products/products-page.component";
import { ShutterComponent } from "./components/smartroom/shutter/shutter.component";
import { LmsComponent } from "./components/smartroom/lms/lms.component";
import { K12Component } from "./components/smartroom/k12/k12.component";
import { SolutionsPageComponent } from "./components/solutions/solutions.component";
import { SolutionDetailComponent } from "./components/solutions/solution-detail/solution-detail.component";
import { ResourcesComponent } from "./components/resources/resources.component";
import { CompanyComponent } from "./components/company/company.component";
import { DealerComponent } from "./components/dealer/dealer.component";
import { ClientLogoSliderComponent } from "./components/home-pannel/client-logo-slider/client-logo-slider.component";
import { DigitalELibraryComponent } from "./components/smartroom/digital-e-library/digital-e-library.component";
import { AiChatWidgetComponent } from "./components/common/ai-chat-widget/ai-chat-widget.component";
import { DigitalContentK12Component } from "./components/blog/digital-content-k12/digital-content-k12.component";
import { ChoosingIfpComponent } from "./components/blog/choosing-ifp/choosing-ifp.component";
import { CommonMistakesBuyingIfpComponent } from "./components/blog/common-mistakes-buying-ifp/common-mistakes-buying-ifp.component";
import { ProtectionMattersIfpComponent } from "./components/blog/protection-matters-ifp/protection-matters-ifp.component";
import { BestLmsForSchoolsIndiaComponent } from "./components/blog/best-lms-for-schools-india/best-lms-for-schools-india.component";
import { SmartPanelProtectionGuideIfpShutterComponent } from "./components/blog/smart-panel-protection-guide-ifp-shutter/smart-panel-protection-guide-ifp-shutter.component";
import { AllInOnePcsForComputerLabsAndOfficesComponent } from "./components/blog/all-in-one-pcs-for-computer-labs-and-offices/all-in-one-pcs-for-computer-labs-and-offices.component";
import { K12DigitalContentForSchoolsComponent } from "./components/blog/k12-digital-content-for-schools/k12-digital-content-for-schools.component";
import { ProjectorVsInteractiveFlatPanelComponent } from "./components/blog/projector-vs-interactive-flat-panel/projector-vs-interactive-flat-panel.component";
import { AiPoweredLmsForSchoolsComponent } from "./components/blog/ai-powered-lms-for-schools/ai-powered-lms-for-schools.component";
import { BestInteractiveFlatPanelsVirsaIfpComponent } from "./components/blog/best-interactive-flat-panels-virsa-ifp/best-interactive-flat-panels-virsa-ifp.component";
import { HowVisualLearningImprovesRetentionComponent } from "./components/blog/how-visual-learning-improves-retention/how-visual-learning-improves-retention.component";
import { InteractivePanelsEngagementComponent } from "./components/blog/interactive-panels-engagement/interactive-panels-engagement.component";
import { HiddenCostPanelDamageComponent } from "./components/blog/hidden-cost-panel-damage/hidden-cost-panel-damage.component";
import { OnePlatformSchoolErpLmsSystemVirsaComponent } from "./components/blog/one-platform-school-erp-lms-system-virsa/one-platform-school-erp-lms-system-virsa.component";
import { VirsaAndroid16InteractiveFlatPanelsComponent } from "./components/blog/virsa-android-16-interactive-flat-panels/virsa-android-16-interactive-flat-panels.component";
import { BecomeVirsaChannelPartnerDistributorComponent } from "./components/blog/become-virsa-channel-partner-distributor/become-virsa-channel-partner-distributor.component";
import { FindThePerfectIfpSizeForYourCampusComponent } from "./components/blog/find-the-perfect-ifp-size-for-your-campus/find-the-perfect-ifp-size-for-your-campus.component";
import { RoleOfInteractiveFlatPanelsInRemoteWorkComponent } from "./components/blog/role-of-interactive-flat-panels-in-remote-work/role-of-interactive-flat-panels-in-remote-work.component";
import { HowSmartClassroomSolutionsHelpSchoolsIncreaseAdmissionsComponent } from "./components/blog/how-smart-classroom-solutions-help-schools-increase-admissions/how-smart-classroom-solutions-help-schools-increase-admissions.component";
import { AllInOnePcsForCodingStemSkillDevelopmentLabsComponent } from "./components/blog/all-in-one-pcs-for-coding-stem-skill-development-labs/all-in-one-pcs-for-coding-stem-skill-development-labs.component";
import { BenefitsOfLockableIfpProtectionShuttersComponent } from "./components/blog/benefits-of-lockable-ifp-protection-shutters/benefits-of-lockable-ifp-protection-shutters.component";
import { HowToChooseAnOpsForAnInteractiveFlatPanelComponent } from "./components/blog/how-to-choose-an-ops-for-an-interactive-flat-panel/how-to-choose-an-ops-for-an-interactive-flat-panel.component";
import { NcertAlignedDigitalK12ContentWhatSchoolsShouldKnowComponent } from "./components/blog/ncert-aligned-digital-k12-content-what-schools-should-know/ncert-aligned-digital-k12-content-what-schools-should-know.component";
import { DigitizeAttendanceExamsHomeworkUsingLmsComponent } from "./components/blog/digitize-attendance-exams-homework-using-lms/digitize-attendance-exams-homework-using-lms.component";
import { BeyondTraditionalBlackboardEraOfInteractiveLearningComponent } from "./components/blog/beyond-traditional-blackboard-era-of-interactive-learning/beyond-traditional-blackboard-era-of-interactive-learning.component";
import { BestInteractiveFlatPanelCompanyInIndiaComponent } from "./components/blog/best-interactive-flat-panel-company-in-india/best-interactive-flat-panel-company-in-india.component";
import { BestK12DigitalContentIndiaComponent } from "./components/blog/best-k12-digital-content-india/best-k12-digital-content-india.component";
import { BestLearningManagementSystemIndiaComponent } from "./components/blog/best-learning-management-system-india/best-learning-management-system-india.component";
import { BestIfpProtectionSlidingShutterIndiaComponent } from "./components/blog/best-ifp-protection-sliding-shutter-india/best-ifp-protection-sliding-shutter-india.component";
import { BestAllInOnePcManufacturerIndiaComponent } from "./components/blog/best-all-in-one-pc-manufacturer-india/best-all-in-one-pc-manufacturer-india.component";



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    HeroBannerComponent,
    LiveActivitiesComponent,
    AboutUSComponent,
    AtSchoolComponent,
    AdvisorsComponent,
    VirsaInsightComponent,
    IntroComponent,
    GenreUnveiledComponent,
    TestimonialsComponent,
    ExpressCuriosityComponent,
    BlogComponent,
    PrivacyComponent,
    TermConditionComponent,
    RefundPolicyComponent,
    SocialInitiativeComponent,
    GenreComponent,
    CareersComponent,
    GenredetailComponent,
    ContactUsComponent,
    BookDemoDialogComponent,
    BookSessionsFormComponent,
    VideoModalComponent,
    BlogDeatilsComponent,
    ConfirmationModalComponent,
    ClassGlimpsesComponent,
    RegisterComponent,
    SignInComponent,
    MastrosComponent,
    AdvisorModalComponent,
    OtpComponent,
    PmShriComponent,
    RazorpayComponent,
    WhatsappComponent,
    PlaylistComponent,
    Page404Component,
    FlatPanelComponent,
    AllInOneComponent,
    ProductsComponent,
    FeatureCardComponent,
    IfpComponent,
    AipComponent,
    HomePannelComponent,
    HeroPannelComponent,
    TestimonialComponent,
    ImpactComponent,
    IccrHeaderComponent,
    LoginComponent,
    SpecTableComponent,
    OneSideImageCardComponent,
    UperImageCardComponent,
    IndustryTabComponent,
    ProductCategoryComponent,
    UspSectionComponent,
    ProductComparisonComponent,
    SolutionsComponent,
    CaseStudiesComponent,
    ProductsPageComponent,
    ShutterComponent,
    LmsComponent,
    K12Component,
    SolutionsPageComponent,
    SolutionDetailComponent,
    ResourcesComponent,
    CompanyComponent,
    DealerComponent,
    ClientLogoSliderComponent,
    DigitalELibraryComponent,
    AiChatWidgetComponent,
    DigitalContentK12Component,
    ChoosingIfpComponent,
    CommonMistakesBuyingIfpComponent,
    ProtectionMattersIfpComponent,
    BestLmsForSchoolsIndiaComponent,
    SmartPanelProtectionGuideIfpShutterComponent,
    AllInOnePcsForComputerLabsAndOfficesComponent,
    K12DigitalContentForSchoolsComponent,
    ProjectorVsInteractiveFlatPanelComponent,
    AiPoweredLmsForSchoolsComponent,
    BestInteractiveFlatPanelsVirsaIfpComponent,
    HowVisualLearningImprovesRetentionComponent,
    InteractivePanelsEngagementComponent,
    HiddenCostPanelDamageComponent,
    OnePlatformSchoolErpLmsSystemVirsaComponent,
    VirsaAndroid16InteractiveFlatPanelsComponent,
    BecomeVirsaChannelPartnerDistributorComponent,
    FindThePerfectIfpSizeForYourCampusComponent,
    RoleOfInteractiveFlatPanelsInRemoteWorkComponent,
    HowSmartClassroomSolutionsHelpSchoolsIncreaseAdmissionsComponent,
    AllInOnePcsForCodingStemSkillDevelopmentLabsComponent,
    BenefitsOfLockableIfpProtectionShuttersComponent,
    HowToChooseAnOpsForAnInteractiveFlatPanelComponent,
    NcertAlignedDigitalK12ContentWhatSchoolsShouldKnowComponent,
    DigitizeAttendanceExamsHomeworkUsingLmsComponent,
    BeyondTraditionalBlackboardEraOfInteractiveLearningComponent,
    BestInteractiveFlatPanelCompanyInIndiaComponent,
    BestK12DigitalContentIndiaComponent,
    BestLearningManagementSystemIndiaComponent,
    BestIfpProtectionSlidingShutterIndiaComponent,
    BestAllInOnePcManufacturerIndiaComponent,


  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule,
    CarouselModule,
    MatDialogModule,
    MatTabsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatSnackBarModule,
    MatPaginatorModule,
    NgApexchartsModule,
    NgOtpInputModule,
    MatDividerModule,
    MatSelectModule,
    MatFormFieldModule,
  ],
  providers: [
    Title,
    Meta,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
